import { Paper, PopoverOrigin, Popover } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { ErrorsList } from './errors/ErrorsList'

interface Props {
  anchorEl: Element | null
  open: boolean
  warnings: object[]
}

const useStyles = makeStyles(theme => ({
  popover: {
    pointerEvents: 'none',
  },
  paper: {
    padding: theme.spacing(2),
    maxWidth: 400,
  },
}))

const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
}

const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'left',
}

export const RowPropertyPopover = ({ anchorEl, open, warnings }: Props) => {
  const classes = useStyles()

  return (
    <Popover
      open={open}
      className={classes.popover}
      anchorEl={anchorEl}
      anchorOrigin={ANCHOR_ORIGIN}
      transformOrigin={TRANSFORM_ORIGIN}
      disableRestoreFocus
    >
      <Paper className={classes.paper}>
        <ErrorsList type="warning" errors={warnings} />
      </Paper>
    </Popover>
  )
}
